import { mapGetters } from 'vuex'

export const reservationsMixin = {
    data() {
        return {
           customerInitializing: true
        }
    },
    computed: {
        ...mapGetters([
            'getSelectedProductCommissions',
            'account',
            'getAudienceTypeList',
            'getEventColors',
            'getReservationCancelNow',
			'getPaymentCancelTypeOptions',
			'getCompanySettings',
            'getLastSavedReservation'
        ]),
        productColor() {
            if (this.reservation.event.product !== undefined && this.reservation.event.product.color !== undefined) {
                // Get event color from store
                let color = this.getEventColors.filter((storedColor) => {
                    return this.reservation.event.product.color == storedColor.id;
                })

                if (color && color.length > 0) {
                    return 'background-color: ' + color[0].code + '; ' + 'border: 1px solid' + color[0].codeSecundary + '; ' + 'color: #222c3c !important;';
                }
            }
        },
        paxTotal() {
            let n = 0;

            if (this.reservation.event !== undefined && this.reservation.event.products !== undefined && this.reservation.event.products) {
                this.reservation.event.product.prices.forEach(price => {
                    n += price.quantity;
                });
            }

            return n;
        },
        refunds() {
            return this.getReservationCalculations ? this.getReservationCalculations.totalRefunds : false;
        },
        totalActuallyPaid() {
            // Cancel (-5) / Pending (-6)
            if (this.reservation.changeStatusTo == '-5' || this.reservation.changeStatusTo == '-6') {
                return this.paid - this.refunds
            } else {
                return this.reservation.billingPaid - this.refunds
            }
        },
        reservationTotalPaid() {
            return this.getReservationCalculations.totalReceived;
        },
        totalPax() {
            let totalPax = 0

            for (let personPrice of this.reservation.bookingGenderPrices) {

                if ([2, 3].includes(personPrice.genderPriceType)) {
                    let quantityPerTicket = personPrice.audienceTypeOccupancy ? personPrice.audienceTypeOccupancy : 1
                    totalPax += personPrice.quantityToBook * Number(quantityPerTicket)
                } else {
                    if (personPrice.genderPriceType == 1 && this.reservation.bookingGenderPrices.length > 1) {
                        totalPax += personPrice.audienceType != null ? personPrice.quantityToBook : 0
                    }

                    if (personPrice.genderPriceType == 1 && this.reservation.bookingGenderPrices.length == 1) {
                        totalPax += 1
                    }
                }
            }
            
            return totalPax
        },
        extrasQuantityTotal() {
            let n = 0;

            this.reservation.event.product.extras.forEach(extra => {
                n += extra.quantity;
            });

            return n;
        },
        extrasPriceTotal() {
            let n = 0;

            this.reservation.event.product.extras.forEach(extra => {
                if (!extra.priceIncluded) {
                    let quantity = extra.item.quantity;
                    let value = extra.item.priceTotal;

                    // If taxes aren't included in the final price we have to add them to calculate the final value
                    if (!extra.item.priceIncludeTaxes && extra.item.vatType != 0) {
                        value = extra.item.priceTotal + (extra.item.priceTotal * extra.item.vatType * 0.01)
                    }

                    n += quantity * value;
                }
            });

            return n;
        },
        extrasTaxPriceTotal() {
            let n = 0;

            this.reservation.event.product.extras.forEach(extra => {
                if (!extra.priceIncluded) {
                    let quantity = extra.item.quantity;
                    let value = extra.item.priceTotal * extra.item.vatType * 0.01;

                    n += quantity * value;
                }
            });

            return n;
        },
        taxesPriceTotal() {
            // The taxes are set in each product and are then calculated from each of the customers' fees
            const product = this.reservation.event.product;
            const tax = product.tax / 100;
            let n = 0;

            if (product.prices.length === 1 && product.prices[0].type === 1 && product.prices[0].audienceType === null) {
                n = product.prices[0].value;
            } else {
                product.prices.forEach(price => {
                    n += price.quantity * price.value;
                });
            }

            return n * tax;
        },
        priceTotal() {
            // The base price is calculated by counting each of the customers' fees
            let n = 0;
            const product = this.reservation.event.product;

            if (product.prices.length === 1 && product.prices[0].type === 1 && product.prices[0].audienceType === null) {
                n = product.prices[0].value;

                if (product.includeTaxes) {
                    n = product.prices[0].value - (product.prices[0].value * product.tax * 0.01);
                }
            } else {
                product.prices.forEach(price => {
                    if (product.includeTaxes) {
                        n += (price.value - (price.value * product.tax * 0.01)) * price.quantity;
                    }
                    else {
                        n += price.quantity * price.value;
                    }
                });
            }

            return n;
        },
        finalPriceWithoutTaxes() {
            // The 'raw' final price (without taxes)
            let value = this.priceTotal + this.extrasPriceTotal;

            return !isNaN(value) ? value : 0;
        },
        finalPrice() {
            // The total amount to pay is the sum of each of the customers' fees plus each of those taxes plus extras plus commission. It's the "actual" total
            let value = this.finalPriceWithoutTaxes + this.taxesPriceTotal;

            return !isNaN(value) ? value : 0;
        },
        outstanding() {
            // The outstanding amount is calculated by subtracting the product's deposit % to the total earnings (plus taxes, minus discount)
            return this.finalPrice - this.deposit;
        },
        deposit() {
            // The deposit is set in the product and is always a percentage of the total earnings (without taxes)
            let value = this.reservation.event.product.paymentValue * (this.priceTotal + this.extrasPriceTotal) / 100;

            return !isNaN(value) ? value : 0;
        },
        commissionPercentage() {
            return this.reservation.event.product.commission * 100;
        },
        commission() {
            // The commission is set in the product and is always a percentage of the total earnings (without taxes)
            let value = this.reservation.event.product.commission * (this.priceTotal + this.extrasPriceTotal);

            return !isNaN(value) ? value : 0;
        },
        reservationTotalCost() {
            if (!this.reservation) {
                return false;
            }

            let totals = {
                withoutDiscount: {
                    noVat: 0,
                    withVat: 0
                },
                withDiscount: {
                    noVat: 0,
                    withVat: 0
                },
                totalTicket: 0,
                totalExtras: 0,
                totalToAgent: 0,
                totalDiscount: 0,
                agentCommission: 0,
                agentDeposit: null,
            }

            // PersonType
            let personTypeArr = [];
            if (this.reservation.event.eventGenderPrices.length > 0) {
                personTypeArr = this.reservation.event.eventGenderPrices;
            } else if (this.reservation.bookingGenderPrices.length > 0) {
                personTypeArr = this.reservation.bookingGenderPrices;

            }

            let reservationAgent = [];
            if (this.reservation.agent && this.reservation.agent > 0) {
                reservationAgent = this.reservation.agent;
            } else if (this.reservation.creatorAgent && this.reservation.creatorAgent.commission && this.reservation.creatorAgent.commission.defaultCommission) {
                reservationAgent = this.reservation.creatorAgent;
            }

            // Ticket cost
            for (let personType of personTypeArr) {
                totals.withoutDiscount.noVat += personType.netprice * personType.quantityToBook;
                totals.withoutDiscount.withVat += personType.grossprice * personType.quantityToBook;
                totals.totalTicket += personType.grossprice * personType.quantityToBook;
            }

            // Extras
            if (this.reservation.event.eventComponents.length > 0) {
                for (let extra of this.reservation.event.eventComponents) {
                    // Both now have taxes, without taxes needs to be worked on
                    totals.withoutDiscount.noVat += extra.component.netprice * extra.quantityBooked;
                    totals.withoutDiscount.withVat += extra.component.grossprice * extra.quantityBooked;
                    totals.totalExtras += extra.component.grossprice * extra.quantityBooked;
                }
            } else {
                for (let extra of this.reservation.event.product.extras) {
                    // Both now have taxes, without taxes needs to be worked on
                    if (extra.quantityBooked) {
                        totals.withoutDiscount.noVat += extra.item.netprice * extra.quantityBooked;
                        totals.withoutDiscount.withVat += extra.item.grossprice * extra.quantityBooked;
                        totals.totalExtras += extra.item.grossprice * extra.quantityBooked;
                    }
                }
            }

            // Aply discount
            let discountValue = this.reservation.billing.discountValue;
            if (this.reservation.billing.discountType == 0) {
                // Discount is eur
                totals.withDiscount.noVat = totals.withoutDiscount.noVat - discountValue;
                totals.withDiscount.withVat = totals.withoutDiscount.withVat - discountValue;
            } else {
                // Discount is percent
                totals.withDiscount.noVat = totals.withoutDiscount.noVat * (1 - (discountValue / 100));
                totals.withDiscount.withVat = totals.withoutDiscount.withVat * (1 - (discountValue / 100));
            }

            // Total discount
            totals.totalDiscount = totals.withoutDiscount.withVat - totals.withDiscount.withVat;

            // Agent commission
            if (this.reservation.billing.agentCommision) {
                let defaultCommission = this.reservation.billing.agentCommision;

                totals.totalToAgent = totals.withDiscount.withVat * (defaultCommission / 100);
                totals.agentCommission = defaultCommission;
            }

            // Depoist
            if (this.reservation.agent) {
                if (this.reservation.agent.depositValue > 0) {
                    // Deposit
                    // DepositType = 0 -> Fixed amount € || DepositType = 1 -> %
                    if (this.reservation.agent.depositType == 1) {
                        totals.agentDeposit = (this.reservation.agent.depositValue / 100) * totals.withDiscount.withVat;
                    } else {
                        if (this.reservation.agent.depositValue > totals.withDiscount.withVat) {
                            totals.agentDeposit = totals.withDiscount.withVat;
                        } else {
                            totals.agentDeposit = this.reservation.agent.depositValue;
                        }
                    }
                } else {
                    // Full amount
                    totals.agentDeposit = totals.withDiscount.withVat;
                }
            }

            return totals;
        },
        paid: {
            get() {
                return this.reservation.billingPaid;
            },
            set(newPaidValue) {
                return newPaidValue;
            }
        },
        due() {
            return this.reservation.billingInDue;
        },
        pendingRefund() {
            if (!this.getReservationCalculations) {
                return false;
            } else {
                var pendingRefundVal = 0;
                
                this.reservation.refunds.forEach(refund => {
                    if(refund.isRequest == true && refund.status == 1){
                        pendingRefundVal += refund.amountResumeValue
                    }
                })

                return pendingRefundVal;
            }
        },
        total() {
            if (!this.getReservationCalculations) {
                return false;
            }

            return this.getReservationCalculations.grandTotal;
        },
        totalDue() {
            if (!this.getReservationCalculations) {
                return false;
            }

            return this.getReservationCalculations.totalInDue; 
        },
        isReservationReadOnly() {
            // -5: canceled | 20: rebooked parent | 5: pending
            const READ_ONLY_STATUSES = new Set([-5, 20, 5]); 
            const reservation = this.reservation;
            if (!reservation) return true;

            // Normalize state values
            const status = Number(reservation.status);
            const originalStatus = reservation.originalStatus == null ? null : Number(reservation.originalStatus);

            // Decision flags
            const isReadOnlyNow = READ_ONLY_STATUSES.has(status);
            const wasReadOnly = originalStatus != null && READ_ONLY_STATUSES.has(originalStatus);
            const changedSinceLoad = originalStatus != null && status !== originalStatus;

            // Policy: read-only if current blocks OR original blocked and it changed but is not saved
            return isReadOnlyNow || (wasReadOnly && changedSinceLoad);
        },
        resourcesWithAvailability() {
            let treatedArray = JSON.parse(JSON.stringify(this.reservation.event.eventResources));
            const usedResourceId = this.reservation.selectedResource ? this.reservation.selectedResource.id : null;
        
            if (this.reservation.event.availabilityType !== 1) {
                treatedArray.map(resource => {
                    if (resource.capacityAvailable >= 0) {
                        resource.name = resource.name + ' (' + resource.capacityAvailable + ')';
                    }
                });
            }
        
            if (usedResourceId) {
                return treatedArray.filter(resource => resource.id !== usedResourceId);
            }

            return treatedArray;
        },
        totalSelectedTickets() {
            let total = 0;

            // This makes this method work on create and edit reservation
            let eventGenderPricesHolder = this.reservation.bookingGenderPrices ? this.reservation.bookingGenderPrices : this.reservation.event.eventGenderPrices;

            if ([2, 3].includes(eventGenderPricesHolder[0].genderPriceType)) {
                for (let personType of eventGenderPricesHolder) {
                    total += personType.quantityToBook;
                }

                return total;
            } else if (eventGenderPricesHolder[0].genderPriceType == 1) {
                // Has particpants (like "Adult", "Children")
                if (eventGenderPricesHolder.filter(genderPrice => genderPrice.isExcludedFromBilling).length > 0) {
                    for (let personType of eventGenderPricesHolder) {
                        total += personType.isExcludedFromBilling ? personType.quantityToBook : 0;
                    }

                    return total;
                } else {
                    // Has no participants, so we count as 1 person
                    return 1;
                }
            }
        },
        loggedUserAccessList() {
            if (!this.getSelectedProductCommissions) {
                return false;
            }

            let thisSellerPermissions = null;

            thisSellerPermissions = this.getSelectedProductCommissions.filter(row => {
                if (row.userAccount) {
                    return row.userAccount.id == this.account.id;
                }
            })[0];

            return thisSellerPermissions;
        },
        selectedSellerAccessList() {
            if (!this.getSelectedProductCommissions) {
                return false;
            }

            let thisSellerPermissions = null;

            if (this.reservation.creatorAgent) {
                thisSellerPermissions = this.getSelectedProductCommissions.filter(row => {
                    if (row.agent) {
                        return row.agent.id == this.reservation.creatorAgent.id;
                    }
                })[0];
            } else if (this.reservation.creatorSupplier) {
                thisSellerPermissions = this.getSelectedProductCommissions.filter(row => {
                    if (row.userAccount) {
                        return row.userAccount.id == this.reservation.creatorUserAccount.id;
                    }
                })[0];
            }

            return thisSellerPermissions;
        },
        reservationHasUnsavedChanges() {
            let output = false;

            for (var key in this.reservation.updateFlags) {
                if (this.reservation.updateFlags.hasOwnProperty(key)) {
                    if (this.reservation.updateFlags[key] == true) {
                        output = true
                    }
                }
            }

            return output;
        }
    },
    methods: {
        saveLastCustomerDetails() {
            let clonedReservationCustomer = JSON.parse(JSON.stringify(this.reservation.customer));
            const now = new Date();
            // 1 hour
            const timeToExpire = 3600000;
            // Inject expire time
            clonedReservationCustomer.expiry = now.getTime() + timeToExpire; 
            // Save customer details
            const lastCustomerDetails = JSON.stringify(clonedReservationCustomer);

            localStorage.setItem('last-customer-details', lastCustomerDetails);
            this.$toasted.info('Customer details saved in memory!');
        },
        fillWithLastCustomerDetails() {
            // Use the last customer details saved
            const keyName = 'last-customer-details';
            let customerDetails = JSON.parse(localStorage.getItem(keyName));
            const now = new Date();

            if (customerDetails && now.getTime() > customerDetails.expiry) {
                this.$toasted.error('No customer details found in memory!');
            } else {
                this.reservation.customer = customerDetails;
                this.$forceUpdate();
            }
        },
        setReservationToCancel(showRefundPopup) {
            // if the reservation is made by GetYourGuide or Pluralo Locals or VIATOR, when canceled it should change to -6 (pending cancelation) else we use -5 (canceled)
            let changeStatusToVal
            
            if (this.getReservationCancelNow == false) {
                // Pending
                changeStatusToVal = "-6"; 
            } else {
                changeStatusToVal = "-5";
            }

            if (showRefundPopup == false) {
                this.$set(this.reservation, 'changeStatusTo', changeStatusToVal);

                return true;

            } else {
                let vm = this;

                return this.$dialog.confirm('\
                    <div class="fs-larg font-weight-600 mb-4">Are you sure you want to cancel this booking?</div>\
                    <p>By cancelling this reservation you must refund your customer.<br>This can not be undone.</p>')
                    .then(() => {
                        vm.$set(vm.reservation, 'changeStatusTo', changeStatusToVal);
                        vm.toggleAddPayment();

                        return true;
                    })
                    .catch(() => {
                        return false;
                    });
            }
        },
        readOnlyShowMessage() {
            this.$toasted.info('This reservation is read only');
        },
        firstResourceWithAvailability() {
            let arrayToSearch = this.resourcesWithAvailability;

            for (let resource of arrayToSearch) {
                if (resource.availability > 0) {
                    return resource;
                }
            }

            // If nothing found return the first resource
            return arrayToSearch[0];
        },
        paxManuallyChanged(personPrice) {
            if (!personPrice) {
                return false;
            }
            if (this.reservation.event.availabilityType != 1 && this.totalSelectedTickets > this.reservation.event.quantityAvailable && !personPrice.audienceTypeOccupancy > 1) {
                personPrice.quantityToBook = 0;
                personPrice.quantityToBook = this.reservation.event.quantityAvailable - this.totalSelectedTickets;
                this.$toasted.info('The value entered is over the available tickets, applied maximum available');
            }

            if (personPrice.audienceTypeOccupancy >= 2 ) {
                const eventAvailability = this.reservation.event.quantityAvailable/personPrice.audienceTypeOccupancy;
                this.newQuantityAvalible = this.reservation.event.quantityAvailable - this.totalPax;

                if (this.newQuantityAvalible >= 0){
                    this.paxManuallyChanged();
                } else if (personPrice.quantityToBook > eventAvailability){
                    personPrice.quantityToBook = 0;
                    this.$toasted.info('The value entered is over the available tickets');
                } else{
                    personPrice.quantityToBook = 0;
                    this.$toasted.info('No more tickets available');
                }
            }

            if (personPrice.quantityToBook < 0) {
                personPrice.quantityToBook = 0;
            }

            if (this.paxManuallyChanged) {
                this.paxManuallyChanged();
            }
        },
        audienceTypeIdToObj(audienceTypeId) {
            if (audienceTypeId) {
                return this.getAudienceTypeList.filter((audienceType) => {
                    return audienceType.id == audienceTypeId;
                })[0];
            } else {
                return null;
            }
        },
        genderPriceObj(personPrice, ignoreAudienceType = false) {
            if (!personPrice.audienceType && !ignoreAudienceType) {
                return null;
            }

            return {
                name: personPrice.audienceTypeDescription,
                description: personPrice.audienceTypeLabel ? personPrice.audienceTypeLabel : null,
            }
        },
        askToOpenPayout() {
            // 0 = Payout, 1 = Refund
			const optionId = this.getCompanySettings.settingsPresets.defaultPaymentCancelationType;
			const optionName = this.getPaymentCancelTypeOptions.find((option) => option.id === optionId).name;
			const optionModal = optionId === 0 ? 'ReservationPayOut' : 'ReservationRefund';

            this.$dialog.confirm(
                `Continue to ${optionName}?`,
                { okText: 'Yes', cancelText: 'No' }
            ).then(() => {
                this.openModal(optionModal);
            }).catch(() => {});
        },
        compareAndSetFlag(flag, newVal, oldVal, options = {}) {
            // Checks if the reservation and flags exist
            if (!this.reservation || !this.reservation.updateFlags) return;
      
            // Option: convert undefined/null to empty string
            if (options.fallbackToEmptyString) {
                newVal = (newVal == null) ? "" : String(newVal);
                oldVal = (oldVal == null) ? "" : String(oldVal);
            }
      
            let changed;
            if (options.isJsonCompare) {
                // Compare complex objects/arrays/structures
                changed = JSON.stringify(newVal) !== JSON.stringify(oldVal);
            } else {
                // Compares simple values (or the string processed above)
                changed = (newVal !== oldVal);
            }
      
            this.$set(this.reservation.updateFlags, flag, changed);
        }
    },
    watch: {
        'reservation.customer': {
            deep: true,
            handler(newVal) {
                if (!this.getLastSavedReservation || !this.getLastSavedReservation.customer) return;
                if (!newVal) return;
        
                this.compareAndSetFlag(
                    'customer',
                    newVal,
                    this.getLastSavedReservation.customer,
                    { isJsonCompare: true }
                );
            }
        },
        'reservation.note': {
            handler(newVal) {
                if (!this.getLastSavedReservation) return;
        
                this.compareAndSetFlag(
                    'customer',
                    newVal,
                    this.getLastSavedReservation.note,
                    { fallbackToEmptyString: true }
                );
            }
        },
        'reservation.bookingOperatorCode': {
            handler(newVal) {
                if (!this.getLastSavedReservation) return;
        
                this.compareAndSetFlag(
                    'voucher',
                    newVal,
                    this.getLastSavedReservation.bookingOperatorCode,
                    { fallbackToEmptyString: true }
                );
            }
        },
        'reservation.selectedResource': {
            deep: true,
            handler(newVal) {
                if (!this.getLastSavedReservation || !this.getLastSavedReservation.selectedResource) return;
                if (!newVal) return;
        
                this.compareAndSetFlag(
                    'reservation',
                    newVal,
                    this.getLastSavedReservation.selectedResource,
                    { isJsonCompare: true }
                );
            }
        },
        'reservation.creatorUserAccount': {
            handler(newVal) {
                if (!this.getLastSavedReservation || !this.getLastSavedReservation.creatorUserAccount) return;
                if (!newVal) return;
        
                this.compareAndSetFlag(
                    'reservation',
                    newVal,
                    this.getLastSavedReservation.creatorUserAccount,
                    { isJsonCompare: true }
                );
            }
        },
        'reservation.changeStatusTo': {
            handler(newVal) {
                if (!this.getLastSavedReservation) return;
        
                this.compareAndSetFlag(
                    'reservation',
                    newVal,
                    this.getLastSavedReservation.changeStatusTo
                );
            }
        },
        'reservation.bookingComponents': {
            deep: true,
            handler(newVal) {
                if (!this.getLastSavedReservation || !this.getLastSavedReservation.bookingComponents) return;
                if (!newVal) return;
        
                this.compareAndSetFlag(
                    'extras',
                    newVal,
                    this.getLastSavedReservation.bookingComponents,
                    { isJsonCompare: true }
                );
            }
        },
        'reservation.paxCheckedIn': {
            handler(newVal) {
                if (!this.getLastSavedReservation) return;

                const original = this.getLastSavedReservation.paxCheckedIn;
                this.compareAndSetFlag('checkins', newVal, original);
            }
        },
        'reservation.paxNoShow': {
            handler(newVal) {
                if (!this.getLastSavedReservation) return;

                const original = this.getLastSavedReservation.paxNoShow;
                this.compareAndSetFlag('checkins', newVal, original);
            }
        },
        'reservation.bookingGenderPrices': {
            deep: true,
            handler(newVal) {
                if (!this.getLastSavedReservation || !this.getLastSavedReservation.bookingGenderPrices) return;
                if (!newVal) return;
        
                this.compareAndSetFlag(
                    'pax',
                    newVal,
                    this.getLastSavedReservation.bookingGenderPrices,
                    { isJsonCompare: true }
                );
            }
        },
        'reservation.transport': {
            deep: true,
            handler(newVal) {
                if (!this.getLastSavedReservation || !this.getLastSavedReservation.transport) return;
                if (!newVal) return;
        
                this.compareAndSetFlag(
                    'transport',
                    newVal,
                    this.getLastSavedReservation.transport,
                    { isJsonCompare: true }
                );
            }
        },
        'reservation.attachCommission': {
            deep: true,
            handler(newVal) {
                if (!this.getLastSavedReservation || !this.getLastSavedReservation.attachCommission) return;
                if (!newVal) return;
        
                this.compareAndSetFlag(
                    'commissions',
                    newVal,
                    this.getLastSavedReservation.attachCommission,
                    { isJsonCompare: true }
                );
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/reservations.js